<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Nuevo amparo / Add Protection</h5>
    <div mat-dialog-content>
      <!--begin::Form-->
      <form class="form" [formGroup]="newProtectionForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
          <br-alert *ngIf="showAlert"></br-alert>
          <p><strong>ID: </strong>1</p>
          <p><strong>Fecha de creación / Date: </strong>{{date | date: 'MMMM d, y'}}</p>
          <mat-form-field class="w-100">
            <mat-label>Amparo / Protection</mat-label>
            <input matInput type="text"
              formControlName="protection" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('protection', 'required')">
              <strong>Campo requerido / Required Field</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <!--end::Form-->
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
      <button mat-button cdkFocusInitial (click)="submit(newProtectionForm)">Guardar / Save</button>
    </div>
</div>
